module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('section', [(_vm.gamesData) ? _h('ul', [_vm._l((_vm.gamesData.games), function(game) {
    return (!_vm.isFiltered(game) && _vm.hasAchievements(game)) ? _h('li', {
      on: {
        "click": function($event) {
          _vm.selectGame(game)
        }
      }
    }, [_h('img', {
      attrs: {
        "src": _vm.apiImage(_vm.imageUrl(game)),
        "alt": game.name
      }
    }), " ", _h('p', [_vm._s(game.name)])]) : _vm._e()
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/schulz/AppData/Roaming/npm/~/vbuild/~/vue-loader/lib/template-compiler.js?id=data-v-bcf014fe!C:/Users/schulz/AppData/Roaming/npm/~/vbuild/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OwnedGames.vue
// module id = 172
// module chunks = 0